import { IEnv } from './environment.interface';

export const environment: IEnv = {
  production: true,
  camApi: {
    baseUrl: 'https://api.udotrucpilot.org/cam'
  },
  geoprocessingApi: {
    baseUrl: 'https://api.udotrucpilot.org/geoprocessing'
  },
  hereApi: {
    // id: 'OMIgHGvZUeSki9FkFYpK',
    // code: 'HfVj3DBsE5EghgVMo32m2g'
    id: '1jNke1nVayWVMmjyoLqh',
    code: '54vvRc_q778iJXd9znBqiw'
  },
  superAdmin: {
    key: 'CRAdmin4321',
  }
};
